/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";

const Component = ({ setDataBanks, setForm2Data, form2Data, savedBanks }) => {
  useEffect(() => {
    let newDataBanks = [...savedBanks.current];

    switch (form2Data.deposit) {
      case "1":
        newDataBanks = newDataBanks.filter(
          (bank) => bank.initial_deposit >= 0 && bank.initial_deposit <= 1000
        );
        break;
      case "2":
        newDataBanks = newDataBanks.filter(
          (bank) => bank.initial_deposit <= 10000
        );
        break;
      case "3":
        newDataBanks = newDataBanks.filter(
          (bank) => bank.initial_deposit <= 50000
        );
        break;
      default:
        break;
    }
    if (form2Data.isRemote === "0") {
      newDataBanks = newDataBanks.filter((bank) => bank.is_remote_opening);
    }
    setDataBanks(newDataBanks);
  }, [form2Data]);

  const onDepositClick = (deposit) => {
    setForm2Data({ ...form2Data, deposit });
  };

  const onRemoteClick = (isRemote) => {
    setForm2Data({ ...form2Data, isRemote });
  };

  return (
    <>
      <div className="mb-6 lg:mb-10">
        <p className="mb-4 font-medium">
          1. What is your acceptable level of initial deposit for opening an
          offshore bank account?
        </p>
        <div className="flex flex-col">
          <button
            onClick={() => onDepositClick("1")}
            className={`mb-4 border-[0.5px] border-bbc-neutral-600 py-2 leading-6 ${
              form2Data.deposit === "1" ? " bg-bbc-primary text-white" : ""
            }`}
          >
            0 - US$ 1000
          </button>
          <button
            onClick={() => onDepositClick("2")}
            className={`mb-4 border-[0.5px] border-bbc-neutral-600 py-2 leading-6 ${
              form2Data.deposit === "2" ? " bg-bbc-primary text-white" : ""
            }`}
          >
            US$ 1001 - US$ 10,000
          </button>
          <button
            onClick={() => onDepositClick("3")}
            className={`mb-4 border-[0.5px] border-bbc-neutral-600 py-2 leading-6 ${
              form2Data.deposit === "3" ? " bg-bbc-primary text-white" : ""
            }`}
          >
            US$ 10,001 - US$ 50,000
          </button>
          <button
            onClick={() => onDepositClick("4")}
            className={`mb-4 border-[0.5px] border-bbc-neutral-600 py-2 leading-6 ${
              form2Data.deposit === "4" ? " bg-bbc-primary text-white" : ""
            }`}
          >
            Above US$ 50,000
          </button>
        </div>
      </div>
      <div className="mb-6 lg:mb-10">
        <p className="mb-4 font-medium">
          2. Can you afford a personal visit of all necessary company’s members
          to bank’s location to perform due diligence process?
        </p>
        <div className="flex flex-col">
          <button
            onClick={() => onRemoteClick("1")}
            className={`mb-4 border-[0.5px] border-bbc-neutral-600 py-2 leading-6 ${
              form2Data.isRemote === "1" ? " bg-bbc-primary text-white" : ""
            }`}
          >
            Yes, of course
          </button>
          <button
            onClick={() => onRemoteClick("0")}
            className={`mb-4 border-[0.5px] border-bbc-neutral-600 py-2 leading-6 ${
              form2Data.isRemote === "0" ? " bg-bbc-primary text-white" : ""
            }`}
          >
            No, I need a remote opening
          </button>
        </div>
      </div>
    </>
  );
};

export default Component;
